import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Column, Row } from 'hedron';
import { DownloadBar as DownloadBarModel } from 'models';
import ds from 'designsystem';
import { media } from 'common/responsive';
import formatFileSize from 'common/methods/formatFileSize';

import Container from 'blocks/Container/Container';

import Header4 from 'elements/Header4';
import Paragraph from 'elements/Paragraph';

import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import BorderedDescription from './BorderedDescription';
import DownloadButton from './DownloadButton';

const DownloadBar = styled.div`
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
  ${media.desktop`
    max-width: 100%;
    height: 120px;
  `}
`;

const DownloadBarBlock = (props) => {
  const {
    data: {
      leftText,
      fileLink: {
        fileName,
        fileType,
        fileSize,
        fileUrl,
      },
      buttonText,
      htmlModifiers,
    },
  } = props;

  return (
    <HTMLModifiableBackground
      htmlModifiers={htmlModifiers}
      color={ds.brand('background')}
    >
      <Container>
        <Row>
          <Column>
            <DownloadBar>
              <Row
                alignItems="center"
                justifyContent="center"
              >
                <Column
                  lg={2}
                  fluid
                >
                  <Header4
                    dangerouslySetInnerHTML={{
                      __html: safeHtmlWithBr(leftText),
                    }}
                  />
                </Column>
                <Column
                  lg={5}
                  fluid
                >
                  <Paragraph
                    dangerouslySetInnerHTML={{
                      __html: safeHtmlWithBr(fileName),
                    }}
                  />
                </Column>
                <Column
                  lg={1}
                  xs={6}
                  fluid
                >
                  <BorderedDescription>
                    {fileType.toUpperCase().slice(12)}
                  </BorderedDescription>
                </Column>
                <Column
                  lg={1}
                  xs={6}
                  fluid
                >
                  <Paragraph>
                    {formatFileSize(fileSize)}
                  </Paragraph>
                </Column>
                <Column
                  lg={2}
                  lgShift={1}
                >
                  <DownloadButton
                    buttonText={buttonText}
                    file={fileUrl}
                    fileName={fileName}
                  />
                </Column>
              </Row>
            </DownloadBar>
          </Column>
        </Row>
      </Container>
    </HTMLModifiableBackground>
  );
};

DownloadBarBlock.propTypes = {
  data: PropTypes.instanceOf(DownloadBarModel).isRequired,
};

export default DownloadBarBlock;



// WEBPACK FOOTER //
// ./src/kentico-blocks/DownloadBar/index.jsx